export const siteName = '西瓜黑料';

export const tickerItems: string[] = [
  '今日新增爆料 186 条 · 已过审 142 条',
  '热帖榜每小时更新一次，当前榜一 12 分钟内涨了 3.4 万热度',
  '合集索引新增「夏日综艺录制现场」分栏',
  '圈内讨论区开放「路过吃瓜」匿名跟帖',
  '本周进度追踪共 9 个事件在跟进中',
];

export const navItems: { key: string; label: string; icon: string }[] = [
  { key: 'latest', label: '最新爆料', icon: 'ri-flashlight-line' },
  { key: 'hot', label: '热帖榜', icon: 'ri-fire-line' },
  { key: 'collection', label: '合集索引', icon: 'ri-bookmark-3-line' },
  { key: 'buzz', label: '圈内讨论', icon: 'ri-chat-smile-2-line' },
  { key: 'track', label: '进度追踪', icon: 'ri-route-line' },
];

export const heroKeywords: string[] = [
  '西瓜黑料最新',
  '西瓜黑料合集',
  '热帖索引',
  '圈内讨论',
  '爆料进度',
  '热搜围观',
];

export const heroStats: { label: string; value: string; hint: string }[] = [
  { label: '在册爆料', value: '24,860', hint: '累计整理入库' },
  { label: '今日新增', value: '186', hint: '较昨日 +32%' },
  { label: '跟进事件', value: '9', hint: '有后续更新' },
  { label: '吃瓜围观', value: '98.2万', hint: '近 24 小时' },
];

export type HotItem = {
  id: string;
  rank: number;
  title: string;
  tag: string;
  heat: string;
  heatPercent: number;
  trend: 'up' | 'down' | 'flat';
  summary: string;
};

export const hotBoardData: HotItem[] = [
  {
    id: 'h1',
    rank: 1,
    title: '夏日综艺录制现场流出的三段花絮，前后细节对不上',
    tag: '争议',
    heat: '38.6万',
    heatPercent: 100,
    trend: 'up',
    summary: '最早一条发布于凌晨两点，三小时后出现对不上时间的第二版说明，评论区已经把两个时间线并排贴在了一起。',
  },
  {
    id: 'h2',
    rank: 2,
    title: '巡演曲目临时调整，粉丝整理出与官宣歌单的七处出入',
    tag: '热议',
    heat: '27.1万',
    heatPercent: 72,
    trend: 'up',
    summary: '有观众按场次做了对比表，发现主歌数量、返场时长与开场前发布的海报并不一致，主办方暂未回应。',
  },
  {
    id: 'h3',
    rank: 3,
    title: '短剧选角路透与最终定档名单，有两个人对调了位置',
    tag: '待跟进',
    heat: '19.4万',
    heatPercent: 54,
    trend: 'flat',
    summary: '路透图里站位的顺序与定档海报明显不同，讨论区有人贴出两版名单的时间戳，目前仍在比对。',
  },
  {
    id: 'h4',
    rank: 4,
    title: '品牌直播连线中途换人，切片被剪成了两个版本传播',
    tag: '围观',
    heat: '14.8万',
    heatPercent: 42,
    trend: 'up',
    summary: '完整回放与传播最广的切片在时长上差了一分半，已被整理进「直播现场」合集里单独成页。',
  },
  {
    id: 'h5',
    rank: 5,
    title: '音乐节阵容排位引发讨论，压轴顺序与预热海报不符',
    tag: '争议',
    heat: '11.2万',
    heatPercent: 33,
    trend: 'down',
    summary: '主办方给出的排期表把两组的出场顺序调换了，讨论区把去年的排位一起拉出来做了横向对照。',
  },
];

export const latestFeed: {
  id: string;
  title: string;
  summary: string;
  author: string;
  time: string;
  comments: number;
  views: string;
  tag: string;
  hot: boolean;
}[] = [
  {
    id: 'f1',
    title: '剧组路透里出现的两版场记板，编号能对上同一天',
    summary: '有网友按场记板编号把当天的多张路透排了序，发现中间有大约四十分钟的拍摄内容没有出现在任何路透里。',
    author: '@前排搬小板凳',
    time: '8 分钟前',
    comments: 264,
    views: '4.1万',
    tag: '最新',
    hot: true,
  },
  {
    id: 'f2',
    title: '综艺官微删掉的一条预告，被存档站原样留了下来',
    summary: '预告里出现的嘉宾顺序与后来正式播出的版本不同，截图与逐帧对照一起被放进了合集索引。',
    author: '@瓜田里的猹',
    time: '21 分钟前',
    comments: 189,
    views: '3.3万',
    tag: '合集',
    hot: true,
  },
  {
    id: 'f3',
    title: '同款舞台造型在两个月内出现两次，细节并不完全一致',
    summary: '服装上的刺绣位置、配饰数量都有细微差别，整理者把两次的清晰图并排放在一起供人比对。',
    author: '@显微镜女孩',
    time: '42 分钟前',
    comments: 132,
    views: '2.7万',
    tag: '细节',
    hot: false,
  },
  {
    id: 'f4',
    title: '某场线下活动的签到顺序表被拍下，与官方通稿不同',
    summary: '签到表上后排的几位在通稿里被写在了前面，发帖人只贴了表格局部，并注明来源为现场观众。',
    author: '@路过围观一下',
    time: '1 小时前',
    comments: 97,
    views: '1.9万',
    tag: '待核实',
    hot: false,
  },
  {
    id: 'f5',
    title: '访谈节目预告与正片问答数量对不上，多出的问题被剪',
    summary: '有观众按字幕时间轴做了对比，正片少了大约三个提问，讨论集中在被剪掉的部分会不会补发。',
    author: '@追更不睡觉',
    time: '2 小时前',
    comments: 76,
    views: '1.5万',
    tag: '剪辑',
    hot: false,
  },
  {
    id: 'f6',
    title: '开票页面的座位图改过一次，前后两版区域划分不同',
    summary: '改版前后的座位图都被截图保存，有买家据此整理出受影响区域的清单，已在评论区置顶。',
    author: '@买票先看这个',
    time: '3 小时前',
    comments: 61,
    views: '1.2万',
    tag: '进度',
    hot: false,
  },
  {
    id: 'f7',
    title: '官方物料里的一处文案在发布后三小时内改过',
    summary: '两版文案的差异只有一句话，存档站保留了最初版本，讨论主要在改动的原因上展开。',
    author: '@存档小分队',
    time: '4 小时前',
    comments: 48,
    views: '9,860',
    tag: '存档',
    hot: false,
  },
  {
    id: 'f8',
    title: '两组艺人的行程图在同一周出现重叠，粉丝各执一词',
    summary: '行程图分别来自两个不同的后援会账号，讨论区把两张图的时间线叠在一起做了标注。',
    author: '@吃瓜第一线',
    time: '5 小时前',
    comments: 203,
    views: '3.8万',
    tag: '热议',
    hot: true,
  },
];

export const collections: {
  id: string;
  title: string;
  count: string;
  updated: string;
  desc: string;
  icon: string;
}[] = [
  {
    id: 'c1',
    title: '夏日综艺录制现场',
    count: '48 条',
    updated: '12 分钟前更新',
    desc: '按录制日期归拢的路透、花絮与场记信息，前后矛盾的地方单独标了备注。',
    icon: 'ri-vidicon-2-line',
  },
  {
    id: 'c2',
    title: '巡演与音乐节排期',
    count: '36 条',
    updated: '1 小时前更新',
    desc: '把官宣歌单、现场排期与观众实拍放在一起，方便对照临时调整的部分。',
    icon: 'ri-music-2-line',
  },
  {
    id: 'c3',
    title: '直播现场切片对照',
    count: '29 条',
    updated: '3 小时前更新',
    desc: '同一场直播的完整回放与传播切片并排收录，标注了剪辑导致的时长差异。',
    icon: 'ri-live-line',
  },
  {
    id: 'c4',
    title: '物料改动存档',
    count: '54 条',
    updated: '今天 09:20 更新',
    desc: '官方文案、海报与预告的改动前后版本，保留发布时间，方便回溯。',
    icon: 'ri-archive-2-line',
  },
  {
    id: 'c5',
    title: '短剧选角与定档',
    count: '22 条',
    updated: '昨天更新',
    desc: '路透与定档名单的时间线整理，站队顺序、海报排位的差异都做了标注。',
    icon: 'ri-film-line',
  },
  {
    id: 'c6',
    title: '线下活动签到与座位',
    count: '17 条',
    updated: '2 天前更新',
    desc: '签到表、座位图与通告单的对照记录，区域变动单独列出。',
    icon: 'ri-map-pin-user-line',
  },
];

export const communityThreads: {
  id: string;
  avatar: string;
  author: string;
  badge: string;
  title: string;
  excerpt: string;
  replies: number;
  time: string;
}[] = [
  {
    id: 't1',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20young%20person%20with%20simple%20geometric%20features%2C%20soft%20warm%20cream%20background%2C%20muted%20watermelon%20green%20and%20crimson%20red%20accents%2C%20clean%20vector%20style%2C%20centered%20square%20composition%2C%20friendly%20modern%20editorial%20look&width=160&height=160&seq=xg-avatar-01&orientation=squarish',
    author: '@瓜田里的猹',
    badge: '常驻整理',
    title: '花絮的时间线我重新排了一遍，两个版本确实对不上',
    excerpt: '按发布顺序重排后，第二版说明出现在第一段花絮之后，但内容里提到的时间却更早，这一点挺值得记一笔。',
    replies: 42,
    time: '6 分钟前',
  },
  {
    id: 't2',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20calm%20young%20woman%20with%20tidy%20short%20hair%2C%20soft%20warm%20cream%20background%2C%20muted%20green%20and%20red%20color%20accents%2C%20clean%20geometric%20vector%20style%2C%20centered%20square%20composition%2C%20modern%20editorial%20illustration&width=160&height=160&seq=xg-avatar-02&orientation=squarish',
    author: '@前排搬小板凳',
    badge: '热帖作者',
    title: '场记板编号的对照表做好了，缺口那四十分钟单独列出来了',
    excerpt: '编号是连续的，中间断掉的部分我单独做成了一张表，谁有当天的路透可以一起补。',
    replies: 67,
    time: '19 分钟前',
  },
  {
    id: 't3',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20focused%20young%20man%20wearing%20glasses%2C%20soft%20warm%20cream%20background%2C%20muted%20green%20and%20crimson%20accents%2C%20clean%20vector%20geometric%20style%2C%20centered%20square%20composition%2C%20editorial%20illustration&width=160&height=160&seq=xg-avatar-03&orientation=squarish',
    author: '@显微镜女孩',
    badge: '细节党',
    title: '舞台造型的刺绣位置对不上，我把两次的清晰图并排放了',
    excerpt: '左边是两个月前那场，右边是这次的，配饰数量差了一个，位置也略有偏移，其他基本一致。',
    replies: 28,
    time: '38 分钟前',
  },
  {
    id: 't4',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20cheerful%20young%20woman%20with%20a%20ponytail%2C%20soft%20warm%20cream%20background%2C%20muted%20watermelon%20green%20and%20red%20tones%2C%20clean%20geometric%20vector%20style%2C%20centered%20square%20composition%2C%20modern%20editorial%20look&width=160&height=160&seq=xg-avatar-04&orientation=squarish',
    author: '@吃瓜第一线',
    badge: '围观群众',
    title: '两张行程图叠在一起看，重叠的那两天挺有意思',
    excerpt: '不是说要争什么，就是单纯叠一下时间线，重叠的地方标注出来了，大家自己看。',
    replies: 91,
    time: '1 小时前',
  },
  {
    id: 't5',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20an%20older%20calm%20person%20with%20short%20hair%2C%20soft%20warm%20cream%20background%2C%20muted%20green%20and%20crimson%20color%20accents%2C%20clean%20simple%20vector%20style%2C%20centered%20square%20composition%2C%20editorial%20illustration&width=160&height=160&seq=xg-avatar-05&orientation=squarish',
    author: '@存档小分队',
    badge: '资料存档',
    title: '物料改动的前后版本都留档了，发布时间也记着',
    excerpt: '改动只有一句话，但前后差了三小时，两个版本我都存了，需要对照的可以直接拿。',
    replies: 15,
    time: '2 小时前',
  },
  {
    id: 't6',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20relaxed%20young%20person%20with%20curly%20hair%2C%20soft%20warm%20cream%20background%2C%20muted%20watermelon%20green%20and%20red%20accents%2C%20clean%20geometric%20vector%20style%2C%20centered%20square%20composition%2C%20modern%20editorial%20illustration&width=160&height=160&seq=xg-avatar-06&orientation=squarish',
    author: '@追更不睡觉',
    badge: '追更党',
    title: '被剪掉的那几个问题会不会补发，有人知道流程吗',
    excerpt: '正片少了三个提问，按字幕时间轴能看出来，想问问这种一般会不会单独补出来。',
    replies: 53,
    time: '3 小时前',
  },
];

export const trackingEvents: {
  id: string;
  title: string;
  status: string;
  progress: number;
  stage: string;
  update: string;
}[] = [
  {
    id: 'e1',
    title: '花絮时间线版本对照',
    status: '跟进中',
    progress: 72,
    stage: '第 3 轮比对',
    update: '15 分钟前有新增',
  },
  {
    id: 'e2',
    title: '巡演曲目出入清单',
    status: '基本清晰',
    progress: 88,
    stage: '已核对 6/7 处',
    update: '1 小时前更新',
  },
  {
    id: 'e3',
    title: '短剧定档名单对调',
    status: '待补充',
    progress: 45,
    stage: '等待第 2 版名单',
    update: '3 小时前更新',
  },
  {
    id: 'e4',
    title: '直播切片时长差异',
    status: '跟进中',
    progress: 60,
    stage: '已标注 4 处剪辑',
    update: '今天 10:40 更新',
  },
];

export const hotSearchWords: string[] = [
  '花絮时间线',
  '巡演曲目',
  '短剧定角',
  '直播切片',
  '音乐节排位',
  '物料改动',
  '签名顺序',
  '座位图',
];

export const footerSections: { title: string; links: string[] }[] = [
  { title: '站内导航', links: ['最新爆料', '热帖榜', '合集索引', '圈内讨论', '进度追踪'] },
  { title: '内容分区', links: ['综艺录制', '巡演音乐', '直播现场', '物料存档', '线下活动'] },
  { title: '参与方式', links: ['投稿爆料', '参与整理', '认领合集', '纠错反馈', '免责声明'] },
];